<div class="support-page">
  <div class="row">
    <div class="col-12 support-page-banner">
      <div class="container-xl">
        <div class="inner-banner">
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="1000">
            <span>Always On</span>: 24/7/365 Customer Service
          </h2>
          <p class="f-m" data-aos="fade-down" data-aos-duration="1000">
            iKunnect ensures that your business remains responsive around the
            clock, providing consistent and reliable support to your customers
            whenever they need it.
          </p>
          <button
            type="button"
            class="primaryBtn ms-4 text-uppercase"
            data-aos="fade-down"
            data-aos-duration="1000"
            (click)="bookConsult()">
            Book a consultation
          </button>
        </div>
        <div class="support-row">
          <div class="support-col">
            <h3 class="f-p">Continuous Support</h3>
            <p class="f-a">
              Ensure your business is always available with 24/7/365 service,
              meeting customer needs anytime, day or night.
            </p>
            <img src="../../assets/images/support-icon.svg" alt="" />
          </div>
          <div class="support-col">
            <h3 class="f-p">Scalability</h3>
            <p class="f-a">
              Easily manage fluctuating call volumes with scalable support,
              handling both peak and off-hour demands seamlessly.
            </p>
            <img src="../../assets/images/scalability-icon.svg" alt="" />
          </div>
          <div class="support-col">
            <h3 class="f-p">Expert Assistance</h3>
            <p class="f-a">
              Benefit from highly trained professionals who deliver efficient,
              effective customer interactions around the clock.
            </p>
            <img src="../../assets/images/assistance-icon.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 customer-expect">
      <div class="container-xl">
        <div class="title">
          <h2 class="f-p" data-aos="fade-down" data-aos-duration="500">
            Customer expectations are higher than ever, and businesses can't
            afford to be unavailable.
          </h2>
          <p class="f-m" data-aos="fade-down" data-aos-duration="600">
            iKunnect solves key business challenges of underperformaing call
            centers
          </p>
        </div>
        <div class="custom-tabs tabs-3">
          <div class="tab-content py-4">
            <div id="tab1" class="tab-pane active">
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-6">
                  <div class="cont">
                    <h6 class="f-p">Live technical support</h6>
                    <p class="f-a">
                      Reach a qualified iKunnect technical expert directly from
                      Monday to Friday, 8:30 AM to 6:00 PM EST (excluding
                      holidays).
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 text-right">
                  <div class="transformCustomer--right">
                    <div class="image-container">
                      <div class="image1">
                        <img src="assets/images/objects-1.png" alt="" />
                      </div>
                      <div class="image2">
                        <img src="assets/images/objects-2.png" alt="" />
                      </div>
                      <div class="image3">
                        <img src="assets/images/objects-4.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab2" class="tab-pane fade">
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-6">
                  <div class="cont">
                    <h6 class="f-p">After-hours and emergency service</h6>
                    <p class="f-a">
                      In the rare event you need assistance outside our regular
                      hours, a live operator will promptly escalate your request
                      to ensure the fastest response time in the industry.
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 text-right">
                  <div class="transformCustomer--right">
                    <div class="image-container">
                      <div class="image1">
                        <img src="assets/images/objects-1.png" alt="" />
                      </div>
                      <div class="image2">
                        <img src="assets/images/objects-2.png" alt="" />
                      </div>
                      <div class="image3">
                        <img src="assets/images/objects-4.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab3" class="tab-pane fade">
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-6">
                  <div class="cont">
                    <h6 class="f-p">Email support</h6>
                    <p class="f-a">
                      For non-urgent inquiries or to share product enhancement
                      ideas, you can email our support team directly. Each
                      request is assigned a ticket number and handled promptly.
                      Over 90% of our support calls are resolved within five
                      minutes.
                    </p>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 text-right">
                  <div class="transformCustomer--right">
                    <div class="image-container">
                      <div class="image1">
                        <img src="assets/images/objects-1.png" alt="" />
                      </div>
                      <div class="image2">
                        <img src="assets/images/objects-2.png" alt="" />
                      </div>
                      <div class="image3">
                        <img src="assets/images/objects-4.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" data-bs-toggle="tab" href="#tab1">
                Live Technical Support
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#tab2">
                After-hours and emergency service
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#tab3">
                Email support
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <app-book-consultation [title]="title" class="spa0 col-12 removePadding" />
  </div>
</div>
